var BASWebServices;
(function (BASWebServices) {
    var ToolTipService = (function () {
        function ToolTipService($rootScope) {
            this.$rootScope = $rootScope;
            this.ttc = null;
        }
        ToolTipService.Factory = function ($rootScope) {
            return new ToolTipService($rootScope);
        };
        ToolTipService.prototype.closeOldAndregisterNewInstance = function (ttcT) {
            if (this.ttc != null && this.ttc != ttcT) {
                this.ttc.closeToolTip();
            }
            this.ttc = ttcT;
        };
        return ToolTipService;
    }());
    BASWebServices.ToolTipService = ToolTipService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ToolTipService.js.map